export interface IKeyValuePair {
    key: string
    value: string
}

function isKeyValuePair(item: unknown): item is IKeyValuePair {
  return (
    item != null &&
    typeof item === 'object' &&
    'key' in item &&
    typeof (item as any).key === 'string' &&
    'value' in item &&
    typeof (item as any).value === 'string'
  );
}

export function isArrayOfKeyValuePairs(arr: unknown): arr is IKeyValuePair[] {
  return Array.isArray(arr) && arr.every(isKeyValuePair);
}